import { getApiData } from "../../app-services";

const getNotificationCounts = (hubId: number,  authentication:any) => {
    return getApiData(`hub/${hubId}/summary`, authentication);
}

export { getNotificationCounts };